import { createFileRoute } from '@tanstack/react-router'
import { scheduleSearchSchema } from '@/features/schedule/model'
import { ScheduleScreen } from '@/features/schedule/routes/schedule-screen'

export const Route = createFileRoute('/schedule')({
  // ?from=YYYY-MM-DD — the first of the two weeks shown.
  validateSearch: scheduleSearchSchema,
  component: SchedulePage,
})

function SchedulePage() {
  return <ScheduleScreen search={Route.useSearch()} />
}
